import { render, staticRenderFns } from "./ErrorSubmitForm2.vue?vue&type=template&id=9015b548&scoped=true"
import script from "./ErrorSubmitForm2.vue?vue&type=script&lang=ts"
export * from "./ErrorSubmitForm2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9015b548",
  null
  
)

export default component.exports